import { THEME } from '@lyon/utils/theme';
import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';
import { ModalOverrides } from 'baseui/modal';

export const MODAL: ModalOverrides = {
  Close: {
    style: {
      display: 'none',

      [THEME.media.medium]: {
        display: 'block',
      },
    },
  },
  Dialog: {
    style: {
      backgroundColor: DARK_MUTED.darkmuted700,
    },
  },
};
